import { c as _c } from "react/compiler-runtime";
import { fetcher } from "@/lib/utils";
import useSWRInfinite from "swr/infinite";
const PAGE_SIZE = 20;
export function getChatHistoryPaginationKey(pageIndex, previousPageData, agentId) {
  if (previousPageData && !previousPageData.chats.length) return null;
  const from = pageIndex * PAGE_SIZE;
  const to = from + PAGE_SIZE - 1;
  return `/api/chat?from=${from}&to=${to}${agentId ? `&agentId=${agentId}` : ""}`;
}
export function useChatHistory(agentId) {
  const $ = _c(3);
  let t0;
  if ($[0] !== agentId) {
    t0 = (pageIndex, prev) => getChatHistoryPaginationKey(pageIndex, prev, agentId);
    $[0] = agentId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fallbackData: []
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useSWRInfinite(t0, fetcher, t1);
}